/* eslint-disable */
/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * Run `npm run generate-api` to regenerate.
 */
import { z } from 'zod';

import { zEnumWithUnknownFallback, zRequired } from '@/shared/redux/api/utils/zod-helpers';

export const billingBackofficeValidators: Record<string, z.ZodTypeAny> = {
  "SewSalesExport": z.object({ "sewSalesExport": z.object({ "data": z.string(), "log": z.string().nullish(), "hasErrors": z.boolean().nullish() }) }),
  "SewCreditConsumptionExport": z.object({ "sewSdaCreditConsumptionExport": z.object({ "data": z.string(), "log": z.string().nullish(), "hasErrors": z.boolean().nullish() }) }),
  "SewSapExport": z.object({ "sewSapExport": z.object({ "data": z.string(), "log": z.string().nullish(), "hasErrors": z.boolean().nullish() }) }),
  "SewInternalSapExport": z.object({ "sewInternalSapExport": z.object({ "data": z.string(), "log": z.string().nullish(), "hasErrors": z.boolean().nullish() }) }),
  "SewInternalCostCenterExport": z.object({ "sewInternalCostCenterExport": z.object({ "data": z.string(), "log": z.string().nullish(), "hasErrors": z.boolean().nullish() }) }),
  "ResalePlansExport": z.object({ "resalePlansExport": z.object({ "url": z.string().nullish() }) }),
};
